<template>
  <div v-if="livingOption" class="living-option">    
    <main-content
      right-sidebar="true"
    >
      <!-- issuu modal -->
      <transition name="fast-fade">
        <div v-if="isIssuuModalActive" class="issuu" @click.stop="isIssuuModalActive = false">
          <div class="issuu__inner">
            <div class="issuu__control-overlay"></div>
            <div style="position:relative;padding-top:max(40%,326px);height:0;width:100%;" @click.stop="">
              <iframe sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox" allowfullscreen="true" style="position:absolute;border:none;width:100%;height:100%;left:0;right:0;top:0;bottom:0;" :src="livingOption.issuuEmbedUrl"></iframe>
            </div>
          </div>
        </div>
      </transition>
      <img v-if="false && livingOption.logo.length" :src="$store.state.assetsPath + livingOption.logo" class="subsection__logo">
      <transition name="fade">
        <image-gallery 
          v-if="!showAllProperties"
          :key="livingOption._id"
          :autoplay="livingOption.imagesAutoplay" 
          :images="livingOption.images" 
          :show-nav="livingOption.imagesShowNav"
        />
      </transition>
      <transition name="fade">
        <img v-if="showAllProperties" class="main-content__background" :key="livingOption.propertiesFloorplate" :src="`${$store.state.assetsPath}${livingOption.propertiesFloorplate}`">
      </transition>
      <transition name="fade">
        <div v-if="showAllProperties">
          <router-link
            v-for="property in properties"
            class="touch"
            :key="property._id"
            tag="div"
            :to="property.routerLink"
          >
            <availability-marker 
              :filtered="property.filter"
              :x="property.livingOptionMarker.x"
              :y="property.livingOptionMarker.y"
              :status="property.status"
            ></availability-marker>
          </router-link>
        </div>      
      </transition>
      <transition name="fade">
        <action-bar v-if="!showAllProperties  && livingOption.subsectionType">{{ actionText }}</action-bar>
      </transition>
    </main-content>
    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="livingOption.sidebarMinimap"
      :heading="livingOption.label[language.code]"
      :description="livingOption.description"
      :navigation-items="navigationItems"
      :enable-slide-out="true"
    >
      <template slot="bottom-slot">
        <button v-if="livingOption.issuuEmbedUrl" class="btn btn--blue touch" @click="openIssuuModal">
          <template v-if="language.code === 'en'">
            {{ isIssuuModalActive ? 'Hide Brochure' : 'View Brochure' }}
          </template>
          <template v-if="language.code === 'ar'">
            {{ isIssuuModalActive ? 'إخفاء الكتيب' : 'عرض الكتيّب' }}
          </template>
        </button>
        <button
          v-if="livingOption.propertiesFloorplate"
          class="btn btn--blue touch"
          @click="toggleShowAllProperties()"
        >{{ showAllProperties ? 'Hide All Properties' : 'View All Properties' }}</button>
        <router-link tag="button" class="right-sidebar__back" to="/live"><fa icon="chevron-left"/>{{ language.code === 'en' ? 'Back' : 'عودة' }}</router-link>
      </template>

      <template slot="slide-out-slot">
        <property-filter/>
      </template>
    </right-sidebar>
  </div>  
</template>
<script>
import ActionBar from '@/components/ActionBar'
import AvailabilityMarker from '@/components/AvailabilityMarker'
import ImageGallery from '@/components/ImageGallery'
import MainContent from '@/components/MainContent'
import PropertyFilter from '@/components/PropertyFilter'
import RightSidebar from '@/components/RightSidebar'
import { mapGetters } from 'vuex'
export default {
  components: { ActionBar, AvailabilityMarker, ImageGallery, MainContent, PropertyFilter, RightSidebar },

  data () {
    return {
      isIssuuModalActive: false,
      showAllProperties: false,
    }
  },

  computed: {
    ...mapGetters ({
      language: 'language',
      livingOption: 'property/activeLivingOption',
      subsectionsWithFiltering: 'property/subsectionsWithFiltering'
    }),

    properties () {
      let properties = []
      this.livingOption.properties.forEach(property => {
        const routerLink = this.generateRouterLink(property._id)
        if (routerLink && property.livingOptionMarker.x !== 100) {
          property.routerLink = routerLink
          property.filter = false
          property.models.forEach(model => {
            const beds = parseInt(model.beds) > 4 ? 4 : parseInt(model.beds)
            if (this.$store.state.property.inputType && this.$store.state.property.inputType !== model.type) {
              property.filter =  true
            } else if ((this.$store.state.property.inputBeds || this.$store.state.property.inputBeds === 0) && this.$store.state.property.inputBeds !== beds) {
              property.filter =  true
            }
          })

          properties.push(property)
        }
      })
      return properties
    },

    actionText () {
      let text = this.livingOption.subsectionType ? this.livingOption.subsectionType.toLowerCase() : 'floor'
      const grammerArticle = ['a', 'e', 'i', 'o', 'u'].includes(text.charAt(0)) ? 'an' : 'a'
      return `select ${grammerArticle} ${text}`
    },

    navigationItems () {
      const navigationItems = this.subsectionsWithFiltering.map(subsection => {
        // HACK: Temp hack to hide this particular subsection - we need a dummy palace property but we dont want to be able to navigate to it
        if (subsection.label !== 'Example Palaces') {
          if (false && subsection.properties.length === 1) { // switching off this condition for now
            const singleProperty = subsection.properties[0]
            return {
              label: subsection.displayName,
              to: `/live/${this.livingOption._id}/subsection/${subsection._id}/property/${singleProperty._id}`,
              disabled: subsection.filter
            }
          } else {
            return {
              label: subsection.displayName,
              to: `/live/${this.livingOption._id}/subsection/${subsection._id}`,
              disabled: subsection.filter
            }
          }
        } else {
          return false
        }
      })

      return navigationItems
    }
  },

  mounted () {
    this.showAllProperties = this.$route.query.showAllProperties
  },

  methods: {
    toggleShowAllProperties () {
      this.showAllProperties = !this.showAllProperties
      this.$router.push({ query: { showAllProperties: this.showAllProperties }})
    },

    openIssuuModal () {
      this.$store.commit('sidebar/CLOSE_SLIDEOUT')
      this.isIssuuModalActive = !this.isIssuuModalActive
    },

    generateRouterLink (id) {
      let routerLink = false
      this.livingOption.subsections.forEach(subsection => {
        if (subsection.propertyIds.includes(id)) {
          routerLink = `/live/${this.livingOption._id}/subsection/${subsection._id}/property/${id}`
        }
      })
      return routerLink
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
.living-option {
  &__logo {
    position: absolute;
    top: 3rem;
    right: 4rem;
    z-index: 999;
    max-height: 10rem;
  }
}

.issuu {
  background: rgba(0, 0, 0, .7);
  bottom: 0;
  display: flex;    
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 10;

  &__inner {
    margin: auto 0 0;
    padding: 10rem;
    width: 100%;
  }

  &__control-overlay {
    background: #1e1e1e;
    bottom: 10rem;
    height: 45px;
    left: 10rem;
    position: absolute;
    right: 10rem;
    overflow: hidden;
    z-index: 10;

    &::before {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABaCAQAAADTVfQ2AAAAPUlEQVR4AU2MAQoAIBDCzuv+/+YQERZDtqDGRztT4hTmwgWS24xMpWseXM7eZyHMQ4bLP3WIObxdOFdIJT+cCQFTpiGPbAAAAABJRU5ErkJggg==);
      background-repeat: repeat-x;
      content: '';
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      height: 89px;
      pointer-events: none;
    }
  }
}
</style>